
    import * as React from 'react';

    const Returns20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Returns_20_svg__Icons/Returns/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M10.4666667,16 L13.1333333,18 L12.5333333,18.8 L8,15.4 L12.5333333,12 L13.1333333,12.8 L10.2,15 L13,15 C15.7614237,15 18,12.7614237 18,10 C18,7.23857625 15.7614237,5 13,5 L11.9285714,5 L11.9285714,4 L13,4 C16.3137085,4 19,6.6862915 19,10 C19,13.3137085 16.3137085,16 13,16 L10.4666667,16 Z M8.66666667,5 L7,5 C4.23857625,5 2,7.23857625 2,10 C2,12.7614237 4.23857625,15 7,15 L7.07142857,15 L7.07142857,16 L7,16 C3.6862915,16 1,13.3137085 1,10 C1,6.6862915 3.6862915,4 7,4 L8.93333333,4 L6,1.8 L6.6,1 L11.1333333,4.4 L6.6,7.8 L6,7 L8.66666667,5 Z" id="Returns_20_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Returns20.displayName = 'Returns20';

    export default Returns20;
  